var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.70874,1.23145a11.00291,11.00291,0,0,0-6.0188,17.97589,1.10108,1.10108,0,0,1,.08057,1.298L3.26489,21.32A1.1,1.1,0,0,0,4.19946,23h7.48462A11.20926,11.20926,0,0,0,22.98071,12.65857,11.01232,11.01232,0,0,0,9.70874,1.23145ZM12,5a1.53845,1.53845,0,1,1-1.53857,1.53845A1.53858,1.53858,0,0,1,12,5Zm1.23047,13H12a.99974.99974,0,0,1-1-1V11.84619h-.23047a1,1,0,0,1,0-2H12a.99974.99974,0,0,1,1,1V16h.23047a1,1,0,0,1,0,2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.daa3ffb2567aed7237bb84a8a4fd8dd8.svg";
export { ForwardRef as ReactComponent };